import { useRef, useState } from "react";
import { ImagePlus, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorText, imgSrc } from "../../lib/api";

export const ImageField = ({ label, hint, value, onChange, fallback, testId }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/admin/uploads", form);
      onChange(data?.url ?? "");
      toast.success("Photo uploaded");
    } catch (e) {
      toast.error(errorText(e));
    } finally {
      setBusy(false);
      if (input.current) input.current.value = "";
    }
  };

  return (
    <div data-testid={testId} className="grid gap-4 sm:grid-cols-[180px_1fr] sm:items-center">
      <div className="relative aspect-[4/3] overflow-hidden rounded-2xl bg-slate-100">
        <img src={imgSrc(value || fallback)} alt="" className="h-full w-full object-cover" />
        {!value ? <span className="absolute bottom-2 left-2 rounded-full bg-white/90 px-2 py-0.5 text-[11px] text-slate-700">Stock photo</span> : null}
      </div>
      <div>
        <p className="text-sm font-semibold">{label}</p>
        <p className="mt-1 text-xs text-slate-600">{hint}</p>
        <div className="mt-3 flex flex-wrap gap-2">
          <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" data-testid={`${testId}-input`} onChange={(e) => upload(e.target.files?.[0])} />
          <button type="button" data-testid={`${testId}-upload-btn`} disabled={busy} onClick={() => input.current?.click()} className="flex items-center gap-2 rounded-full bg-[#0B192C] px-4 py-2 text-sm text-white transition-colors duration-200 hover:bg-[#1E3E62] disabled:opacity-60">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImagePlus className="h-4 w-4" />}
            {busy ? "Uploading…" : value ? "Replace photo" : "Upload photo"}
          </button>
          {value ? (
            <button type="button" data-testid={`${testId}-remove-btn`} onClick={() => onChange("")} className="flex items-center gap-2 rounded-full border border-slate-300 px-4 py-2 text-sm text-slate-700 transition-colors duration-200 hover:bg-slate-100">
              <Trash2 className="h-4 w-4" /> Remove
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};
